import React from 'react';
import { GameConsoleView } from './console-react';
import { getFilenameWithoutExtension, Named } from './util';
import { GameSource } from './game-pure';

function GameConsolePage() {

    const fileSources: Named<GameSource>[] = [];

    const addUrl = (url: string): void => {
        const name = getFilenameWithoutExtension(url);

        fileSources.push({ type: 'xml', source: { type: 'fetch', url}, name });
    }

    // addUrl('./res/games/baufirma/baufirma.xml');
    // addUrl('./res/games/jack-frost/jack-frost.xml');
    // addUrl('./res/games/ozean/ozean.xml');
    addUrl('./res/games/island-en/SQL_Island_en.xml');
    addUrl('./res/games/island/SQL_Island.xml');
    // addUrl('./res/games/island-dev/island-dev.xml');
    // addUrl('./res/games/sql-jungle/sql-jungle.xml');
    addUrl('./res/games/MSE-2026/SQL_Island_Sequel_MIN_MAX_ANY_T1.xml');
    addUrl('./res/games/MSE-2026/SQL_Island_Sequel_INTERVAL_T2.xml');
    addUrl('./res/games/MSE-2026/SQL_Island_Sequel_FILTER_T3.xml');
    addUrl('./res/games/MSE-2026/SQL_Island_Sequel_Anti-JOINs_T5.xml');
    addUrl('./res/games/MSE-2026/SQL_Island_Sequel_ARRAY_T6.xml');
    addUrl('./res/games/MSE-2026/SQL_Island_Sequel_Window_Functions_T7.xml');
    addUrl('./res/games/MSE-2026/SQL_Island_Sequel_Top-N_Queries_T8.xml');
    addUrl('./res/games/MSE-2026/SQL_Island_Sequel_CTE_T9.xml');
    
    
    return (
        <div className="p-4">
            <div className='eskuel'>
                <div className='app-browser'>
                    <GameConsoleView fileSources={fileSources}/>
                </div>
            </div>
        </div>
    );
  }

export default GameConsolePage;
